<div class="w-full h-full flex justify-center items-center">
  <mat-spinner [diameter]="diameter" *ngIf="showSpinner; else textMessage" [ngClass]="classList"></mat-spinner>
  <ng-template #textMessage>
    <p class="mb-4">{{ message }}</p>
  </ng-template>
</div>
